import React, { useCallback, useMemo, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryBase from "../components/EntryBase";
import EntryGrid from "../components/EntryGrid";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getformid, getcontroller, getsubkey, getWindowDimensions, setglobaldata, GetExtension,
    NumConv, DicVal, getglobaldata, DeepCopy, initializedata, RandomKey, Savestorage, Getstorage,
    GetDesitRound, GetRound, isEnabled, CellType, numformat, removeglovaldata, Loadstorage 
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, reports, entryformlock, entrytriggercall,readonly } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';
import { AgGridReact } from "ag-grid-react";
import { themeBalham } from 'ag-grid-community';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));


export const ShnOrder = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", ROW: "1", IMAGE: "pic",  FILE: "file", TOTAL:"T1" }
    const primarykeys = ["SHD_DENNO", "SHDM_DENNO", "SHDTH_DENNO"];
    const TRANTYPE = { NONE: "0", PROG: "1" }

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const entrylock = useSelector(state => state.form.entryformlock);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themestyle = useSelector(state => state.form.themestyle);
    const baseref = useRef();
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiRefrow = useRef({ grid: undefined, column: undefined });
    const apiReftotal = useRef({ grid: undefined, column: undefined });
    const apirow = apiRefrow.current;
    const apitotal = apiReftotal.current;
    const allotgridRef = useRef(null);
    const CalcParam = useRef({ taxrate: 0.1, amtround: 1, taxround: 1 });
    const locationstate = useRef(null);    //遷移State
    const transinfo = useRef(null);        //遷移情報
    const csvRef = useRef(null);

    const entrydataRef = useRef(null);    //基本情報データ
    const orderrowsRef = useRef(null);    //発注明細データ
    const ordercolRef = useRef(null);     //発注明細列情報  
    const totalRef = useRef(null);        //発注合計データ
    const totalcolRef = useRef(null);   　//発注合計列情報  
    const imageRef = useRef(null);        //画像
    const fileRef = useRef(null);         //ファイル  

    const shops = useRef([]);           //配分納品先
    const storeallot = useRef([]);      //配分データ
    const storeorder = useRef([]);      //前回発注データ

    const modifyRef = useRef(false);    //変更フラグ
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const formlock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [rowmode, setrowmode] = useState(0);      //0:発注明細 1:納品先配分
    const [rowData, setRowData] = useState([]);     //納品先配分データ
    const [columnDefs, setcolumnDefs] = useState([]);
    const [rowDragManaged, setrowDragManaged] = useState(true);
    const [update, setUpdata] = useState(false);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [supallot, setsupallot] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const [pricetype, setpricetype] = useState(0);
    const [priceftype, setpriceftype] = useState(0);

    const dispatch = useDispatch();
    const CELLTYPE = CellType();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const RowNodeId = data => data.rowid;
    const formid = getformid("ShnOrder", props.location.search);
    const controller = getcontroller("ShnOrder", props.location.search);
    const subkey = getsubkey(props.location.search);
    const reportsRef = useRef(null);

    const actionurl = {
        "delete": "shnorder/Delete",
        "getlist": "shnorder/GetListData",
        "update": "shnorder/Update",
    }
    const navmenu = [
        { status: "ENTRY FORM", menuid: "withdraw", icon: "cancel", label: "申請解除" },
        { status: "ENTRY FORM", menuid: "sep" },
        { status: "ENTRY FORM", menuid: "print1", icon: "print", label: "製商品発注書発行" },
        { status: "ENTRY FORM", menuid: "print2", icon: "print", label: "加工指示書発行" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title:"現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "print1", icon: "print", label: "製商品発注書発行" },
        { status: "VIEW", menuid: "print2", icon: "print", label: "加工指示書発行" },
    ]

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "1", action: "INSERT" },
        { type: "2", action: "INSERT" },
        { type: "0", action: "UPDATE" },
        { type: "1", action: "UPDATE" }
    ];

    function resolveNavMenu() {
        const canWithdraw = DicVal(entrydataRef.current, "SHD_REQFLG", "") === "1";
        let skipNextSeparator = false;
        let items = navmenu.filter(item => {
            if (item.menuid === "withdraw") {
                skipNextSeparator = !canWithdraw;
                return canWithdraw;
            }

            if (skipNextSeparator && item.menuid === "sep") {
                skipNextSeparator = false;
                return false;
            }

            skipNextSeparator = false;
            return true;
        });

        if (formlock || supallot) {
            items = items.filter(e => (formlock && e.menuid !== 'formupload') || (supallot && e.class !== 'allot'));
        }

        return items;
    }
    
    function rerender() {
        setUpdata(update ? false : true);
    }
    function statusKey(id) {
        return formid + "entry_" + id;
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }
    function tabchange(tab) {
        if (tab === '2') {  //納品先タブの場合
            baseref.current.ChangeNavmenu(navmenu.filter(e => e.status !== "VIEW" || e.menuid === "excel"));
            baseref.current.hideMenucmd([{ status: "UPDATE", cmd: "削除" }]);
        } else {
            baseref.current.ChangeNavmenu(navmenu);
        }
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(reports(data.reports));
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    reportsRef.current = data.reports;
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    //列情報初期化
                    ordercolRef.current = null;
                    totalcolRef.current = null;

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    let key = search.split("key=")[1];
                    if (isEmpty(state) && !isEmpty(key)) {
                        let calldata = Loadstorage(key);
                        state = calldata?.state;  //他画面からの連携情報取得
                    }
                    locationstate.current = state;
                    transinfo.current = null;
                    if (!isEmpty(state)) {
                        transinfo.current = Object.assign({}, state);     //LIST情報保持
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search]);


    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);


    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    useEffect(() => {
        if (isEmpty(entrydataRef.current)) return;
    }, [formstatus]);


    function TryCallShow() {
        if (isEmpty(locationstate.current)) {
            return;
        }
        callshow();
    }
    function Transtype() {
        if (isEmpty(transinfo.current)) return TRANTYPE.NONE;
        if (transinfo.current.accepttype === "WorkProgMgr") return TRANTYPE.PROG;   //作業・進捗管理
        return TRANTYPE.NONE;
    }

   //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            if (Transtype() === TRANTYPE.PROG) {    //作業・進捗管理
                document.title += " <作業・進捗管理>";
                baseref.current.NotShowStatus(true);    //CANCEL無効
                dispatch(readonly({ readonly: true, ctrls: menuinfo.ctrls }));
            }
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                AcceptAction(locationstate.current.acceptno);
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }
    //受入処理
    function AcceptAction(value) {
        var state = locationstate.current;
        var others = null;
        if (!isEmpty(state.detail)) others = [state.detail];
        fnc.current.postaxios('shnorder/GetAccept', { type: state.accepttype, "keys": value, "colinfo": columninfo, addinfo: others },
            {
                onSuccess: function (data) {
                    try {
                        fnc.current.margeMaster(data.master);
                        entrydataRef.current = data.data;
                        orderrowsRef.current = data.detail["120"];
                        storeorder.current = DeepCopy(orderrowsRef.current); //発注データ保存
                        if (data.detail["shop"].length !== 0) shops.current = data.detail["shop"];
                        setstoreallot(data.detail["detail"]);
                        //合計セット
                        SetTotalData(data.detail["120"], true);

                        showpanel('0', '130', (data.data['SHD_SHOKUFLG'] === '1'));

                        //setpricetype(0);
                        //setpriceftype(0);

                        rerender();
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                errmsg: "処理に失敗しました"
            }
        )
    }

    function setsliplock(value) {
        dispatch(entryformlock(value));
    }

    function onGridReady(param, id) {
        if (id === G_id.ROW) {
            apiRefrow.current.grid = param.api;
            apiRefrow.current.column = param.columnApi;
            //遷移起動処理
        //    TryCallShow();
        }
        if (id === G_id.TOTAL) {
            apiReftotal.current.grid = param.api;
            apiReftotal.current.column = param.columnApi;
            //遷移表示
            TryCallShow();
        }
    }
   function onFirstDataRendered(param, id) {
    //    if (id === G_id.ROW) {
    //        apiRefrow.current.grid = param.api;
    //        apiRefrow.current.column = param.columnApi;
    //    }
    //    if (id === G_id.TOTAL) {
    //        apiReftotal.current.grid = param.api;
    //        apiReftotal.current.column = param.columnApi;
    //        if (isEmpty(locationstate.current)) {
    //        //    RowDataChanged();
    //        } else {
    //            //遷移表示
    //            TryCallShow();
    //        }
    //    }
    }

    function MenuAction(action, finallycallback, param) {
        SaveStorage();   //現在レイアウト保持
        if (action === 'save') {
            Save(finallycallback);
        }
        if (action === 'delete') {
            Delete(finallycallback);
        }
        if (action === "clear") {
            clearform(true);
        }
        if (action === 'linkfield') {
            switch (finallycallback.table) {
                case "D_SHD":
                    let type = "100";
                    let col = textfields.find(e => e.columnid === finallycallback.field);
                    if (col !== undefined) {
                        type = col.type;
                        let key = finallycallback.field + "_" + type;
                        document.getElementById(key).focus();
                        document.getElementById(key).select();
                    }
                    Jump(G_id.BASE, type);
                    break;
                case "D_SHDM":
                    Jump(G_id.ROW);
                    AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, apirow.grid);
                    break;
                default:
                    break;
            }
        }
        if (action === "print1") {      //製商品発注書発行
            let code = [];
            if (formstatus === "ENTRY FORM") {
                if (entrydataRef.current["SHD_SYNFLG1"] !== '2') {
                    fnc.current.warnmsg("承認されていない為印刷できません");
                    return;
                }
                code = [edittingcode];
            } else {
                let param = baseref.current?.GetSelectrowdata();
                if (param.length === 0) {
                    fnc.current.warnmsg("対象データを選択してください");
                    return;
                }
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            if (param[j]["SHD_SYNFLG1"] === '2') {      //承認済のみ
                                code.push(param[j][primarykeys[i]]);
                            }
                        }
                        break;
                    }
                }
                if (code.length === 0) {
                    fnc.current.warnmsg("承認済のデータが選択されていません");
                    return;
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('SeihinHachuShoReport/Generate', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
        if (action === "print2") {      //加工指示書発行
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                let param = baseref.current?.GetSelectrowdata();
                if (param.length === 0) {
                    fnc.current.warnmsg("対象データを選択してください");
                    return;
                }
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('shnorder/PrnKakolist', { controller: controller, keys: code },
            {
                onSuccess: function (data) {
                    var keys = data.keys.join(",");;
                    fnc.current.postaxios('KakoShijishoReport/Generate', { controller: controller, id: action, ssdNo: keys },
                        {
                            onSuccess: function (data) {
                                let params = {
                                    "excelfile": data.returnData["filename"],
                                    "dnfile": data.returnData["dnfile"]
                                }
                                fnc.current.filedownload("excel/ExcelDownload", params);
                                fnc.current.wait(false);
                            },
                            errmsg: "処理に失敗しました"
                        }
                    )
                },
                errmsg: "処理に失敗しました"
            }
            )

        }
        if (action === 'withdraw') {    //申請解除
            if (entrydataRef.current["SHD_REQFLG"] === '0') {
                fnc.current.warnmsg("このデータは申請されていません");
                return;
            }
            if (entrydataRef.current["SHD_SYNFLG1"] === '2') {
                fnc.current.warnmsg("承認済のデータは変更不可です");
                return;
            }
            if (entrydataRef.current["SHD_SYNFLG1"] === '3') {
                fnc.current.warnmsg("却下のデータは変更不可です");
                return;
            }
            let msg = "申請解除します。宜しいでしょうか？";
            fnc.current.confmsg(msg, () => exec());
            function exec() {
                fnc.current.postaxios('shnorder/CancelApp', { "code": edittingcode },
                    {
                        onSuccess: function (data) {
                            entrydataRef.current["SHD_REQ"] = "";
                            entrydataRef.current["SHD_REQFLG"] = "0";   //未申請
                            baseref.current?.ChangeNavmenu(resolveNavMenu());
                            fnc.current.wait(false);
                        },
                        errmsg: "処理に失敗しました"
                    }
                )
            }
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('shnorder/GetDataTree', { "code": code },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }
    function Show(data,pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code==="");
        //データ読み込み
        LoadData(code);
        return true;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('shnorder/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = data.data;
                            orderrowsRef.current = data.detail["120"];
                            //合計セット
                            SetTotalData(data.detail["120"], true);

                            storeorder.current = DeepCopy(orderrowsRef.current); //発注データ保存
                            if (data.detail["shop"].length !== 0) shops.current = data.detail["shop"];
                            setstoreallot(data.detail["detail"]);

                            showpanel('0', '130', (data.data['SHD_SHOKUFLG'] === '1'));

                            //承認後ロック
                            var ids = ["SHD_HACHUBI", "SHD_SIIRETANTOCD", "SHD_SHOKUNM", "SHD_SHOKUKANA", "SHD_SHOKUCOUNTYCD", "SHD_SHOKUBUMONMEI",
                                        "SHD_SHOKUYUBIN","SHD_SHOKUSTATEMEI","SHD_SHOKUCITYMEI","SHD_SHOKUTOWNMEI", "SHD_SHOKUADDR",
                                        "SHD_SHOKUBUILMEI", "SHD_SHOKUTEL", "SHD_SHOKUFAX", "SHD_SHOKUTANTOMEI", "SHD_KEIYAKUNO", "SHD_SHOP"];
                            changecelllock(ids, data.data["SHD_REQ"] === '承認済み');

                            //setpricetype(0);
                            //setpriceftype(0);

                            //imageRef.current = data.images;
                            //fileRef.current = data.files;
                            //dispatch(setimagelist(data.images));

                            //受入済の場合行入れ替え不可
                            //let lock = data.row.some(e => e.lockrow);
                            //setrowDragManaged(!lock);
                            //setsliplock(data.data["d_order_p_lock"] !== "0");   //伝票ロックか
                            //if (formlock) entrydataRef.current["d_order_p_lock"] = "1";
                            rerender();
                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }
    //編集ロック
    function changecelllock(columnids, locked) {
        const updateColumns = (fields) => {
            if (isEmpty(fields) || !Array.isArray(columnids)) return fields;

            let changed = false;
            const newfields = DeepCopy(fields);

            newfields.forEach(field => {
                if ( columnids.includes(field.columnid) && field.locked !== locked ) {
                    field.locked = locked;
                    changed = true;
                }
            });

            return changed ? newfields : fields;
        };

        settextfieldsall(prev => updateColumns(prev));
        settextfields(prev => updateColumns(prev));
    }
    function normalizeGridCode(value) {
        if (isEmpty(value)) return "";
        return String(value).split(':')[0];
    }

    function normalizeFixFlg(value) {
        if (value === true || value === 1 || value === "1") return "1";
        return "0";
    }

    function getShopSubCd(shop) {
        return DicVal(shop, "subCd",
            DicVal(shop, "subcode",
                DicVal(shop, "SHDTH_TENPOSUBCD",
                    DicVal(shop, "TOR_SUBCD",
                        DicVal(shop, "TOR_SUBCODE", "00000")))));
    }

    function sameShop(left, right) {
        return left.code === right.code && getShopSubCd(left) === getShopSubCd(right);
    }

    function getCurrentAllotRows() {
        if (!isEmpty(allotgridRef.current?.api) && !isEmpty(AGRef.current?.GetDatasource)) {
            return AGRef.current.GetDatasource(allotgridRef.current.api);
        }
        return storeallot.current || [];
    }


   function setstoreallot(allotdata,init) {
        var newdata = [];
        let rows = orderrowsRef.current;
        if (rows.length === 0 || shops.current.length === 0) {
            storeallot.current = [];
            return;
        }
        for (let r = 0; r < rows.length; r++) {
            let allot = [];
            for (let i = 0; i < shops.current.length; i++) {
                let row = { code: shops.current[i].code, name: shops.current[i].name, kubun: shops.current[i].kubun, rowid: rows[r].rowid }
                var info = allotdata.find(e => e["SHDTH_GYONO"] === rows[r]["SHDM_GYONO"] && e["SHDTH_COLORCD"] === rows[r]["SHDM_COLORCD"].split(':')[0] &&
                    e["SHDTH_SIZECD"] === rows[r]["SHDM_SIZECD"].split(':')[0] && e["SHDTH_TENPOCD"] === shops.current[i].code);
                if (!isEmpty(info)) {
                    row["qty"] = info["SHDTH_HAIBUNSU"];
                }
                //発注数をセット
                if (isEnabled(init)) row["qty"] = rows[r]["SHDM_SEIHATCHUSU"];
                allot.push(row);
            }
            let data = DeepCopy(rows[r]);
            data["callRecords"] = allot;
            newdata.push(data);
        };
        storeallot.current = newdata;
    }

    //明細合計セット
    function SetTotalData(data, init) {
        //総合計
        let total = { qty: 0, amt: 0, curamt: 0 };
        for (let i = 0; i < data.length; i++) {
            total.qty += NumConv(data[i]["SHDM_SEIHATCHUSU"]);
            total.amt += NumConv(data[i]["SHDM_AMOUNT"]);
            total.curamt += NumConv(data[i]["SHDM_AMOUNTF"]);
        }

        //ブランド別品番集計
        const totalsByNo = data.reduce((result, row) => {
            const ssdNo = row.PDT_SYOHINCD;
            if (!result[ssdNo]) {
                result[ssdNo] = {
                    rowid : ssdNo,
                    BRHINBAN : ssdNo,
                    TOTALQTY: 0,
                    TOTALAMT: 0,
                    TOTALAMTF: 0
                };
            }
            result[ssdNo].TOTALQTY += Number(row.SHDM_SEIHATCHUSU) || 0;
            result[ssdNo].TOTALAMT += Number(row.SHDM_AMOUNT) || 0;
            result[ssdNo].TOTALAMTF += Number(row.SHDM_AMOUNTF) || 0;

            return result;
        }, {});

        var totaldata = Object.values(totalsByNo);
        totaldata.push({ grip:"計", rowid: "TOTAL", TOTALQTY: total.qty, TOTALAMT: total.amt, TOTALAMTF: total.curamt });
        totalRef.current = totaldata;
    }
    function RowValueChanged(colid, targets, panel) {
        RowDataChanged(panel);
    }
    //Grid Row Data Change
    function RowDataChanged(panel) {
        if (isEmpty(entrydataRef.current)) return;
        var data = orderrowsRef.current;
        if (isEmpty(data)) data = [];

        for (let i = 0; i < data.length; i++) {
            //金額再計算
            var qty = NumConv(data[i]["SHDM_SEIHATCHUSU"]);
            if (entrydataRef.current["SHD_TSUKATANI"] !== "JPY") {
                data[i]["SHDM_AMOUNTF"] = calcamount(qty, data[i]["SHDM_SEIHATCHUTANKAF"], 1);
            } else {
                data[i]["SHDM_SEIHATCHUTANKAF"] = 0;
                data[i]["SHDM_SEIKAKUTEITANKAF"] = 0;
                data[i]["SHDM_AMOUNTF"] = 0;
            }
            data[i]["SHDM_AMOUNT"] = calcamount(qty, data[i]["SHDM_SEIHATCHUTANKA"], 0);
        }

        fnc.current.rerenderGrid(panel.id);
        SetTotalData(data);
        fnc.current.rerenderGrid("T" + panel.id);
    }
    function ChangeRowValue(params, panel) {
        if (params.column.colDef.colinfo.datatype !== CELLTYPE.NUM) {
            storeRowData(panel);
            return;
        }
        var rowdata = orderrowsRef.current.find(e => e.rowid === params.data.rowid);
        if (entrydataRef.current["SHD_TSUKATANI"] !== "JPY" && !isEmpty(rowdata)) {
            if (params.column.colId === "SHDM_SEIHATCHUTANKA") {
                //外貨単価を取得
                rowdata["SHDM_SEIHATCHUTANKAF"] = ExchangePrice(params.newValue, 1);
            }
            if (params.column.colId === "SHDM_SEIHATCHUTANKAF") {
                //円単価を取得
                rowdata["SHDM_SEIHATCHUTANKA"] = ExchangePrice(params.newValue, 0);
            }
        }
        RowDataChanged(panel);
    }
    //金額計算
    function calcamount(qty, price, mode) {
        var amt = NumConv(qty) * NumConv(price);
        if (mode === 0) {   //円
            return GetRound(amt, 0);
        } else {            //外貨
            return GetDesitRound(amt, 0, 2);
        }
    }
//外貨→円、円→外貨変換
    function ExchangePrice(price, mode) {
        var rate = NumConv(entrydataRef.current["SHD_SHANAIRATE"]);
        if (mode === 0) {   //外貨→円
            return GetRound(rate * price, 0);
        } else {            //円→外貨
            return GetDesitRound(price / rate, 0, 2);
        }
    }

    //明細カラム定義
    function ColdefSpecial(column) {
        if (column.colId === "SHDTH_FIXFLG") {
            column.datatype = CELLTYPE.CHECK;
            column.colinfo = { ...column.colinfo, datatype: CELLTYPE.CHECK };
            column.width = 56;
            column.cellClass = "ag-center-aligned-cell";
        }
        if (formstatus !== "ENTRY FORM") return;
    }

    function rowmodeChange() {
        if (rowmode === 0) {    //発注明細→納品先配分
            storeRowData();
            setrowmode(1);
            createAllotdata(false);
        } else {                //納品先配分→発注明細
            storeallot.current = AGRef.current.GetDatasource(allotgridRef.current.api); //配分データ保存
            setrowmode(0);
            removeglovaldata("ShnOrderCopyRate", false);    //コピーされた配分比率クリア
        }
    }
    function initshop() {
        if (DicVal(entrydataRef.current, "SHD_REQ", "") === "承認済み") {
            return;
        }
        if (shops.current.length > 0) {
            let msg = "既に納品先が設定されています。選択した納品先に変更されますよろしいですか？";
            if (shops.current.length > 1) {
                msg = "複数納品先が設定されています。選択した単一の納品先に全数配分されますよろしいですか？";
            }
            fnc.current.confmsg(msg, () => callselectlist(false, createinitallot));
        } else {
            callselectlist(false, createinitallot);
        }
        //配分データを作成する
        function createinitallot(e) {
            fnc.current.searchlistclose();
            let data = e.items[0].data;
            var shop = { code: data.code, name: data.TOR_NAME, kubun: data.TOR_KUBUN };
            shops.current = [shop];
            storeallot.current = [];
            setstoreallot(orderrowsRef.current, true);
            createAllotdata(true);
        }
    }
    function callselectlist(multi, Apply) {
        //検索条件に使用するブランドを取得
        const brandlists = [
            ...new Set(orderrowsRef.current.map(row => row.PDT_SYOHINCD?.slice(0, 3))
                    .filter(Boolean)
            )
        ];
        entrydataRef.current = {
            ...entrydataRef.current,
            BRANDLIST: brandlists.join(",")
        };
        fnc.current.searchlistopen({
            label: "納品先",
            multiple: multi,
            rowmode: false,
            data: { dataid: 'V_ALLOCATE', datatype: CELLTYPE.MASTERCODE, initial: true },
            rowdata: entrydataRef.current,
            rowid: null,
            currowid: null,
            doApply: Apply,
        });
    }
    function addshop() {
        if (DicVal(entrydataRef.current, "SHD_REQ", "") === "承認済み") {
            return;
        }
        storeallot.current = AGRef.current.GetDatasource(allotgridRef.current.api); //配分データ保存
        callselectlist(true, Apply);
        function Apply(e, mode) {
            fnc.current.searchlistclose();
            for (let i = 0; i < e.items.length; i++) {
                let data = e.items[i];
                let result = shops.current.find(e => e.code === data.code);
                if (isEmpty(result)) {
                    shops.current.push({ code: data.code, name: data.TOR_NAME , kubun:data.TOR_KUBUN});
                }
            }
            let result = shops.current.sort(function (a, b) {
                return (a.code < b.code) ? -1 : 1;
            });
            shops.current = result;
            createAllotdata(true);
        }
    }

    const formatNumber = (params) => {
        let colinfo = params.colDef.colinfo;
        if (isEmpty(colinfo)) return params.value;
        if (colinfo.datatype === CELLTYPE.NUM) {
            var number = Number(params.value);
            return numformat(number, colinfo);
        }
        return params.value;
    };
    function createAllotdata(shopchange) {
        let g_column = DeepCopy(ordercolRef.current);
        var colDef = g_column.filter(e => e.field !== 'grip');
        let column = { field: 'total', colId:'total', headerName: "配分計", width: 80 };
        AGRef.current.SetColDefTypeInfo(CELLTYPE.NUM, column);
        colDef.push(column);
        column = {
            field: 'rest', colId: 'rest', headerName: "配分残", width: 80,
            cellStyle: function (params) {
                if (Number(params.value) < 0) {
                    return { backgroundColor: 'pink' };
                }else if (Number(params.value) > 0) {
                    return { backgroundColor: 'honeydew' };
                } else {
                    return { backgroundColor: 'inherit' };
                }
            }
        };
        AGRef.current.SetColDefTypeInfo(CELLTYPE.NUM, column);
        colDef.push(column);
        colDef = colDef.map(obj => {
            obj.editable = false;
            obj.resizable = true;
            obj.filterType = "multi";
            obj.menuTabs = ['filterMenuTab'];
            obj.valueFormatter = formatNumber;
            obj.sortable = false;
            if (obj.colId === "SHDM_SEIHATCHUSU" || obj.colId === "total" || obj.colId === "rest") {
                obj.pinned = 'right';
            }
            if (obj.colId === "SHDM_SSDNO") obj.cellRenderer = "agGroupCellRenderer";
            return obj
        });
        setcolumnDefs(colDef);

        var newdata = [];
        let rows = orderrowsRef.current;
        if (rows.length === 0 || shops.current.length === 0) {
            setRowData(newdata);
            return;
        }
        if (JSON.stringify(rows) === JSON.stringify(storeorder.current) && !shopchange) {
            //変更なしの場合前回データセット
            setRowData(storeallot.current); 
            return;
        }
        storeorder.current = DeepCopy(rows); //発注データ保存
        for (let r = 0; r < rows.length; r++) {
            let allot = [];
            for (let i = 0; i < shops.current.length; i++) {
                let row = { code: shops.current[i].code, name: shops.current[i].name, kubun: shops.current[i].kubun, rowid: rows[r].rowid }
                var rowdata = storeallot.current.find(e => e.rowid === rows[r].rowid);
                if (!isEmpty(rowdata)) {
                    let rec = rowdata.callRecords.find(e => e.code === shops.current[i].code);
                    if (!isEmpty(rec)) row["qty"] = rec.qty;
                }
                allot.push(row);
            }
            let row = DeepCopy(rows[r]);
            row["callRecords"] = allot;
            newdata.push(row);
        };
        setRowData(newdata);

    }

    //配分計、配分残を算出セット
    function setTotalAllotQty(node, qty) {
        if (isEmpty(AGRef.current)) return;
        let src = AGRef.current.GetDatasource(allotgridRef.current.api);
        let data = src.find(e => e.rowid === node.rowid);
        if (isEmpty(data)) return;
        let rows = data.callRecords;
        let total = 0;
        for (let i = 0; i < rows.length; i++) {
            if (node.code === rows[i].code) {
                total += qty;
            } else {
                if (!isNaN(rows[i].qty)) {
                    total += Number(rows[i].qty);
                }
            }
        }
        let rowNode = allotgridRef.current.api.getRowNode(node.rowid);
        if (!isEmpty(rowNode)) {
            rowNode.setDataValue("rest", data['SHDM_SEIHATCHUSU'] - total);
            rowNode.setDataValue("total", total);
        }
    }
    const qtyFormatter = (params) => {
        var number = 0;
        if (!isNaN(params.value)) {
            number = Number(params.value);
        }
        setTotalAllotQty(params.data, number);
        return currencyFormatter(params);
    };
    const currencyFormatter = (params) => {
        if (isNaN(params.value)) return '';
        var number = Number(params.value);
        return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    const detailCellRendererParams = useMemo(() => {
        return {
            detailGridOptions: {
                columnDefs: [
                    { headerName: "納品先", field: 'code' },
                    { headerName: "納品先名", field: 'name' },
                    {
                        headerName: "配分数", field: 'qty', editable: true, cellClass: "ag-right-aligned-cell", filter: "agNumberColumnFilter", width: 100,
                        valueFormatter: qtyFormatter
                    },
                ],
                defaultColDef: {
                    sortable: true,
                    filter: true,
                    resizable: true
                },
                columnMenu: "legacy",
                rowSelection: 'multiple',
                enableRangeSelection: true,
                suppressMultiRangeSelection: true,
                getContextMenuItems: getContextMenuItems,
                enableFillHandle: true,
                fillHandleDirection: 'y'
            },
            getDetailRowData: (params) => {
                params.successCallback(params.data.callRecords);
            },
        };
    }, []);

    function getContextMenuItems(params) {
        var lock = entrydataRef.current["d_order_p_lock"] ==="1";
        var result = [];
        if (!lock) {
            result = [{
                name: '納品先削除',
                action: function () {
                    const selectedRows = params.api.getSelectedRows();
                    if (!selectedRows || selectedRows.length === 0) {
                        fnc.current.warnmsg("行を選択してください");
                        return;
                    }
                    if (orderrowsRef.current.some(e => e.lockrow)) {
                        //削除可能かチェック
                        fnc.current.postaxios("shnorder/ExistShopAllot",
                            {
                                code: entrydataRef.current["SHD_DENNO"],
                                rowdata: selectedRows
                            },
                            {
                                onSuccess: function (data) {
                                    if (data.request === "OK") {
                                        let msg = "すべての発注明細から選択された納品先を削除します。よろしいですか？";
                                        fnc.current.confmsg(msg, () => deleteshop(selectedRows));
                                    }
                                    else {
                                        if (selectedRows.length === 1) fnc.current.warnmsg("受入済の納品先の為削除できません");
                                        else fnc.current.warnmsg("受入済の納品先が含まれています");
                                    }
                                    fnc.current.wait(false);
                                },
                                errmsg: "処理に失敗しました"
                            }
                        )
                        return;
                    }
                    let msg = "すべての発注明細から選択された納品先を削除します。よろしいですか？";
                    fnc.current.confmsg(msg, () => deleteshop(selectedRows));
                },
            },
            ];
        }
        return result;
    };
    function deleteshop(rows) {
        storeallot.current = AGRef.current.GetDatasource(allotgridRef.current.api); //配分データ保存
        for (let i = 0; i < rows.length; i++) {
            let code = rows[i].code;
            shops.current = shops.current.filter(e => e.code !== code);
            for (let r = 0; r < storeallot.current.length; r++) {
                let row = storeallot.current[r];
                let rec = row.callRecords.filter(e => e.code !== code);
                row.callRecords = rec;
            }
        }
        setRowData(storeallot.current);
    }

    function onAllotFirstDataRendered(params){
        setTimeout(function () {
            params.api.forEachNode(function (node) {
                node.setExpanded(true);
            });
        }, 0);
    };

    function allotcheck(rows) {
        let rest = false;
        for (let i = 0; i < storeallot.current.length; i++) {
            let row = rows.find(e => e.rowid === storeallot.current[i].rowid);
            if (isEmpty(row)) continue;
            let t = 0;
            for (let j = 0; j < storeallot.current[i].callRecords.length; j++) {
                let allot = storeallot.current[i].callRecords[j];
                t += NumConv(allot.qty);
            }
            //発注数＜配分数
            if (t > NumConv(row["SHDM_SEIHATCHUSU"])) return false;
            //発注数＞配分数
            if (t < NumConv(row["SHDM_SEIHATCHUSU"])) rest = true;
        }
        return rest?9:true;
    }
    function Save(finallycallback) {
        if (rowmode === 0) {
            storeRowData();
            //無効行を除く
            let row = orderrowsRef.current;
            storeallot.current = storeallot.current.filter(e => row.find(r => r.rowid, e.rowid) !== null);
        }
        else storeallot.current = AGRef.current.GetDatasource(allotgridRef.current.api);

        let allot = [];
        for (let i = 0; i < storeallot.current.length; i++) {
            allot = [...allot, ...storeallot.current[i].callRecords];
        }
        let row = orderrowsRef.current;
        if (!AGRef.current.ExistValidRow(orderrowsRef.current, columninfo, ordercolRef.current)) {
            fnc.current.warnmsg("有効な発注明細が存在しません");
            return;
        }
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        if (supallot) {
            Apply();
        } else {
            //納品先配分有り
            if (allot.length === 0 ) {
                let msg = "配分が行われていません。登録してよろしいですか？";
                fnc.current.confmsg(msg, () => Apply());
            } else {
                switch (allotcheck(row)) {
                    case false:
                        fnc.current.warnmsg("配分数が発注数を超えている明細が存在します");
                        return;
                    case true:
                        Apply();
                        break;
                    default:
                        let msg = "配分残が存在します。登録してよろしいですか？";
                        fnc.current.confmsg(msg, () => Apply());
                        break;
                }
            }
        }
        function Apply() {
            if (formstatus === "ENTRY FORM") {  //更新
                const paramdata = {
                    "controller": formid,
                    "data": entrydataRef.current,
                    "colinfo": columninfo,
                    "code": edittingcode
                }
                fnc.current.postaxios("shnorder/WarningCheck", paramdata,
                    {
                        onSuccess: function (data) {
                            if (data.warning.length === 0) {
                                ApplyExec();
                                return;
                            }
                            const msgs = data.warning.map(item => item.message);
                            fnc.current.confmsg(msgs, () => ApplyExec(), () => fnc.current.wait(false));
                            fnc.current.wait(false);
                        },
                        errmsg: "登録確認に失敗しました"
                    }
                )
            } else {        //新規登録
                ApplyExec();
            }
        }
        function ApplyExec() {
            if (isEmpty(entrydataRef.current)) entrydataRef.current = {};
            const savecolumninfo = SaveColumnInfo();
            var detail = {};
            detail["120"] = row;
            detail["detail"] = allot;
            const paramdata = {
                "controller": formid,
                "data": entrydataRef.current,
                "detail": detail,
                "images": imageRef.current,
                "files": fileRef.current,
                "colinfo": savecolumninfo,
                "code": edittingcode,
                type: baseref.current.ListType()
            }
            fnc.current.postaxios(formstatus === "ENTRY FORM" ? "shnorder/UpdateEntry" : "shnorder/InsertEntry", paramdata,
                {
                    onSuccess: function (data) {
                        if (data.warning.length === 0) {
                            fnc.current.modify(false);
                            let code = data.request;
                            if (formstatus !== "ENTRY FORM") {
                                entrydataRef.current["SHD_DENNO"] = data.request;
                                setedittingcode(data.request);
                                dispatch(changestatus("ENTRY FORM"));
                            }
                            if (newfiles.length !== 0) {        //v1.4
                                //新規ファイルアップロード
                                cfFileUpload("shnorder", code, newfiles, fnc, () => LoadData(code));
                            } else {
                                if (formstatus === "ENTRY FORM") {
                                    //Listに反映
                                    finallycallback(null, data.datas, primarykeys);
                                }
                                LoadData(code);     //再表示
                                fnc.current.success();
                            }
                        }
                        else {
                            setrowmode(0);
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                        fnc.current.wait(false);
                    },
                    errmsg: "登録に失敗しました"
                }
            )
        }
    }
    function SaveColumnInfo() {
        if (isEmpty(columninfo)) return [];

        return columninfo.filter(col => {
            if (isEmpty(col)) return false;

            if (col.logpid === G_id.BASE) {
                return panel.some(p => p.id === G_id.BASE && p.type === col.type && !panelhidden(p));
            }

            if (!isEmpty(col.logpid) && col.logpid.startsWith("T")) {
                return panel.some(p => p.id === col.logpid.substring(1) && !panelhidden(p));
            }

            if (panel.some(p => p.id === col.logpid && !panelhidden(p))) return true;
            if (panel.some(p => p.type === col.type && !panelhidden(p))) return true;

            return false;
        });
    }

   function Delete(finallycallback) {
       const param = {
           rowdata: [{ "rowid": edittingcode }],
           controller: controller
       }
        fnc.current.postaxios("shnorder/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }

    //行挿入前イベント
    function QueryInsertRow(row) {
        if (formstatus === "ENTRY FORM") {
            //指定行が受け入れ済の場合エラー
            if (isEnabled(row.data.lockrow)) {
                fnc.current.warnmsg("この明細は受入済の為行挿入できません");
                return false;
            }
            //指定行以降に受け入れ済が存在する場合エラー
            for (let i = row.rowIndex + 1; i < orderrowsRef.current.length; i++) {
                if (isEnabled(orderrowsRef.current[i]["lockrow"])) {
                    fnc.current.warnmsg("受入済明細が存在する為行挿入できません");
                    return false;
                }
            }
        }
        return true;
    }
    //行削除前イベント
    function QueryRemoveRow(rows) {
        if (formstatus === "ENTRY FORM") {
            for (let i = 0; i < rows.length; i++) {
                if (isEnabled(rows[i].lockrow)) {
                    if (rows.length === 1) fnc.current.warnmsg("この明細は受入済の為行削除できません");
                    else fnc.current.warnmsg("受入済の明細が含まれている為行削除できません");
                    return false;
                }
            }
        }
        return true;
    }
    //ファイル取込
    const onFileInputChange = (event) => {
        const file = event.target.files[0];
        event.target.value = "";
        if (!validFileType(file)) {
            fnc.current.warnmsg("ファイル形式が無効です。Excelファイルを指定してください。");
            return;
        }
        if (file.size > 10000000) {
            fnc.current.warnmsg("選択ファイルはアップロード可能なファイルサイズを超えています。");
            return;
        }
        fnc.current.formdialogopen(
            {
                title: "Excelデータ取込", dialogtype: 9,
                customcontents: 2,
                checkboxlabel: "先頭行を取り込む（ヘッダ行がないExcelシートの取り込みの場合チェック）",
                contents: "納品先配分データを取り込みます。よろしいですか？",
                onApply: (param) => CSVImport(file, param.check)
        });
        function validFileType(file) {
            switch (file.type) {
                case "application/vnd.ms_excel":
                    return true;
                default:
                    if (GetExtension(file.name) === "xlsx") {
                        return true;
                    }
                    break;
            }
            return false;
        }
    };
    function CSVImport(file, mode) {
        fnc.current.formdialogclose();
        let param = {
            "file": file,
            "importmode": false,
            "colcount":5,
        }
        fnc.current.fileupload('excel/GetExcelFileData', param,
            {
                onSuccess: function (data) {
                    storeallot.current = AGRef.current.GetDatasource(allotgridRef.current.api);
                    let allot = [];
                    for (let i = 0; i < storeallot.current.length; i++) {
                        allot = [...allot, ...storeallot.current[i].callRecords];
                    }
                    //CSVデータ
                    var csvdata = data.data.map(row => row.join(','));

                    var detail = {};
                    detail["120"] = orderrowsRef.current;
                    detail["detail"] = allot;
                    detail["shop"] = shops.current;
                    const paramdata = {
                        "detail": detail,
                        "keys":csvdata
                    }
                    fnc.current.postaxios('shnorder/GetImportData', paramdata,
                        {
                            onSuccess: function (data) {
                                if (data.returnData["total"] === data.returnData["err"]) {
                                    fnc.current.confmsg("取込可能なデータが存在しませんでした", () => ErrDownload(data), null, "エラーログ出力");
                                } else {
                                    shops.current = data.detail["shop"];
                                    setcellrecord(data.detail["shop"], data.detail["detail"]);
                                    createAllotdata(true);
                                    if (data.returnData["err"] !== "0") {
                                        fnc.current.confmsg(data.returnData["total"] + "件中" + data.returnData["err"] + "件のデータが取込できませんでした", () => ErrDownload(data), null, "エラーログ出力");
                                    }
                                }
                                fnc.current.wait(false);
                            },
                            errmsg: "取り込みに失敗しました"
                        }
                    );
                },
                errmsg: "取り込みに失敗しました"
            }
        );
        function setcellrecord(shops, allot) {
            var newdata = [];
            let rows = orderrowsRef.current;
            if (rows.length === 0 || shops.length === 0) {
                storeallot.current = [];
                return;
            }
            for (let r = 0; r < rows.length; r++) {
                let cellrecord = [];
                for (let i = 0; i < shops.length; i++) {
                    let row = { code: shops[i].code, name: shops[i].name, kubun: shops[i].kubun, rowid: rows[r].rowid }
                    var info = allot.find(e => e["rowid"] === rows[r]["rowid"] && e["code"] === shops[i].code);
                    if (!isEmpty(info)) {
                        row["qty"] = NumConv(info["qty"]);
                    } else {
                        row["qty"] = 0;
                    }
                    cellrecord.push(row);
                }
                let data = DeepCopy(rows[r]);
                data["callRecords"] = cellrecord;
                newdata.push(data);
            };
            storeallot.current = newdata;
        }
        function ErrDownload(param) {
            const lines = param.warning.map(
                warning => `${warning.rowid}行目　${warning.message}`
            );
            const text = lines.join("\r\n");
            const blob = new Blob(["\uFEFF" + text], {
                type: "text/plain;charset=utf-8"
            });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "エラーログ.txt";
            link.click();

            URL.revokeObjectURL(link.href);
        }
    }
    //CSV取込
    function Importfile() {
        if (DicVal(entrydataRef.current, "SHD_REQ", "") === "承認済み") {
            return;
        }
        csvRef.current.click();
    }

    //Basic Data Change
    function ValueChanged(id, value) {
    }

    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined || panel === G_id.ROW) {
            orderrowsRef.current = AGRef.current.GetDatasource(apirow.grid);
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.ROW) panelid = rowmode === 0 ? 'rowGrid' :'allotGrid';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        } catch { }
    }
    //入力フィールドクリア
    function clearform(newform) {
        setsliplock(false);
        setrowmode(0);
        entrydataRef.current = initializedata(textfieldsall, staff);
        orderrowsRef.current = [{ rowid: RandomKey() }];
        CalcParam.current = { taxrate: 0.1, amtround: 1, taxround: 1 };
        totalRef.current = [{ rowid: "TOTAL", grip: "計", d_order_p_taxkind:"0" }];
        shops.current = [];
        storeallot.current = [];
        dispatch(setimagelist([]));
        imageRef.current = null;
        fileRef.current = null;
        fnc.current.modify(false);
        modifyRef.current = false;
        //列情報初期化
        ordercolRef.current = null;
        totalcolRef.current = null;

        if (isEnabled(newform)) {
            fnc.current.getTaxrate("", (tax, taxs) => taxApply(tax, taxs, false, true));
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }

    }
    //レイアウト保持
    function SaveStorage() {
        //列情報保存
        AGRef.current.SaveColState(statusKey(G_id.ROW), EmptyPanel(G_id.ROW) ? null : apirow.column);
        AGRef.current.SaveColState(statusKey(G_id.TOTAL), EmptyPanel(G_id.TOTAL) ? null : apitotal.column);
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }
    function EmptyPanel(id, type) {
        try {
            let tbltype = tabletype(id);
            return isEmpty(columns.find(e => e.type === tbltype));
        } catch { return false; }
    }
    //パネル別列情報取得
    function tabletype(id) {
        if (id.substr(0, 1) === "T") {  //Total
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    if (setbase) break;
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        coldef.push({
                            headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                            type: fds[f].type
                        });
                    }
                    setbase = true;
                    break;
                case G_id.ROW:
                    cols = AGRef.current.GetshownColDef(apirow.column);
                    break;
                default:
                    continue;
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        //Total Grid
        cols = AGRef.current.GetshownColDef(apitotal.column);
        for (let i = 0; i < cols.length; i++) {
            let col = DeepCopy(cols[i]);
            col.type = tabletype(G_id.TOTAL);
            coldef.push(col);
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    var type = tabletype(G_id.ROW);
                    var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    ordercolRef.current = coldef;
                    type = tabletype(G_id.TOTAL);
                    coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    totalcolRef.current = coldef;
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current))  return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }

    function getOrderContextMenuItems(params) {
        var result = [
            {
                name: 'Expand(全開)',
                action: function () {
                    setTimeout(function () {
                        params.api.forEachNode(function (node) {
                            node.setExpanded(true);
                        });
                    }, 0);
                },
            },
            {
                name: 'collapse(全閉)',
                action: function () {
                    setTimeout(function () {
                        params.api.forEachNode(function (node) {
                            node.setExpanded(false);
                        });
                    }, 0);
                },
            }
        ];
        return result;
    };
    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    //明細編集セル制御
    function RowlockCell(params, edit, status, tabvalue) {
        if (params.colDef.colId === "SHDM_SEIHATCHUTANKA" || params.colDef.colId === "SHDM_SEIHATCHUTANKAF") {
            if (DicVal(params.data, "SHDM_HATCHKFLG", "") === "1") return false;    //発注単価確認フラグが1（確認済み）の場合編集不可
        }
        if (params.colDef.colId === "SHDM_SEIHATCHUTANKAF") {
            return entrydataRef.current["SHD_TSUKATANI"] !== "JPY";
        }
        return edit;
    }


    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }
    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock}/>
                ))}
            </ul>
        );
    });
    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.ROW && props.rowmode===0) {
            return (
                <React.Fragment>
                    <EntryGrid
                        id={props.panel.id}
                        elemid="rowGrid"
                        entrydataRef={entrydataRef}
                        dataRef={orderrowsRef}
                        columnRef={ordercolRef}
                        columninfo={columninfo}
                        columns={columns}
                        modifyRef={modifyRef}
                        type={tabletype(G_id.ROW)}
                        fnc={fnc}
                        onGridReady={onGridReady}
                        onFirstDataRendered={onFirstDataRendered}
                        statusKey={formid + "entry_" + G_id.ROW}
                        ColdefSpecial={ColdefSpecial}
                        AutoAddRow={false}
                        rowDragManaged={false}      //並び替え不可
                        rowContext={1}
                        lockcell={RowlockCell}
                        panel={props.panel}
                        ValueChanged={(e) => ChangeRowValue(e, props.panel)}
                        RowValueChanged={(colid, rows) => RowValueChanged(colid, rows, props.panel)}
                        RemoveRow={() => RowDataChanged(props.panel)}
                    />
                    {EmptyPanel(G_id.TOTAL) ? null :
                        <EntryGrid
                            id={"T" + props.panel.id}
                            elemid="totalGrid"
                            dataRef={totalRef}
                            columnRef={totalcolRef}
                            columninfo={columninfo}
                            columns={columns}
                            type={tabletype(G_id.TOTAL)}
                            fnc={fnc}
                            onGridReady={onGridReady}
                            onFirstDataRendered={onFirstDataRendered}
                            statusKey={formid + "entry_" + G_id.TOTAL}
                            total={true}
                        />
                    }
                </React.Fragment>
            );
        }
        if (props.panel.id === G_id.ROW && props.rowmode === 1) {
            return (
            <div id="allotGrid" className="ag-theme-balham" style={{ width: '100%' }}>
                    <AgGridReact
                        theme={themeBalham}
                        columnMenu="legacy"
                        ref={allotgridRef}
                        columnDefs={columnDefs}
                        popupParent={document.querySelector('body')}
                        masterDetail={true}
                        detailRowAutoHeight={true}
                        detailCellRendererParams={detailCellRendererParams}
                        rowData={rowData}
                        getRowNodeId={RowNodeId}
                        headerHeight={30}
                        domLayout={'autoHeight'}
                        onFirstDataRendered={onAllotFirstDataRendered}
                        getContextMenuItems={getOrderContextMenuItems}
                   />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        return null;

    }
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name === '' ? <div style={{ display: 'inline-block', height: 10 }}></div> : p.name}
                                    {p.name2 !== '' ? '-': ''}
                                    <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {p.id !== '1' ? null :
                                        <React.Fragment>
                                        {rowmode === 0 || formlock ? null :
                                            <div style={{ position: 'absolute', left: 100, top: -3 }}>
                                            <Button size="small" onClick={Importfile}
                                                style={{
                                                    width: 100, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 750, marginRight: 20
                                                }}
                                            >
                                                納品先CSV取込
                                            </Button>
                                                <Button size="small" onClick={initshop} 
                                                style={{
                                                    width: 100, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 700, marginRight: 20
                                                }}
                                            >
                                                納品先設定
                                            </Button>
                                                    <Button size="small" onClick={addshop} style={{ marginLeft: 10 }}
                                                    style={{
                                                        width: 100, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 700, marginRight: 20
                                                    }}
                                                >
                                                    納品先追加
                                                </Button>
                                            </div>
                                            }

                                            {supallot ? null :
                                            <div style={{ position: 'absolute', right: 100, top: -3 }}>
                                            <Button size="small" endIcon={<Icon style={{ fontSize: 16 }}>arrow_forward</Icon>} onClick={ rowmodeChange}>
                                                {rowmode === 0 ? "納品先詳細" : "発注明細"}
                                            </Button>
                                            </div>
                                        }
                                        </React.Fragment>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} rowmode={ rowmode} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                ref={baseref}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                entryform={true}
                tabs={true}
                show={Show}
                primarykey={primarykeys}
                entrydataRef={entrydataRef}
                navmenu={formlock || supallot ? navmenu.filter(e => (formlock && e.menuid !== 'formupload') || (supallot && e.class !== 'allot')) : navmenu}
                suppressaction={suppressaction}
                usecondition={true}
                tabvalueChange={tabchange }
           >
            <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.2,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <input
                hidden
                ref={csvRef}
                type="file"
                onChange={onFileInputChange}
            />
            <DataTree code={edittingcode} />
        {/*    <DropZone*/}
        {/*        code={edittingcode}*/}
        {/*        open={isDragActive}*/}
        {/*        onclose={FileDropClose}*/}
        {/*        actionurl={actionurl}*/}
        {/*        uploaded={fileuploaded}*/}
        {/*    />*/}
        </div>
    );
};
